import {
  UserAddOutlined,
  UserOutlined,
  MailOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { Button, FloatButton, Form, Input, Modal, Select } from "antd";
import "./UserComponent.css";
import { useState, useEffect } from "react";
import { CreateUser } from "../../Repository/UserManagementRepository";
import { SuccessMessage } from "../../Utils/Utils";
import { useDispatch } from "react-redux";
import { GetUsersDataAction } from "../../redux/UserManagementRedux/UserManagementAction";
import { GetUsers } from "../../Repository/UserManagementRepository";
const UserCreation = () => {
  // State and constants
  const [ShowCreateUser, setShowCreateUser] = useState(false);
  const { Option } = Select;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [roles, setRoles] = useState([]);

  // Function to fetch users and roles data
  const fetchUserData = async () => {
    try {
      const usersData = await GetUsers(); // Assuming GetUsers fetches users data with roles
      const uniqueRoles = [...new Set(usersData.map((user) => user.Role))]; // Extract unique roles from users data
      setRoles(uniqueRoles); // Set unique roles to the state
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  // Fetch users and roles data on component mount
  useEffect(() => {
    fetchUserData();
  }, []);

  // Function to handle user creation
  const HandleCreateUser = async (values) => {
    values["Rg_Id"] = 0;
    const Response = await CreateUser(values);
    if (Response != null) {
      setShowCreateUser(false);
      SuccessMessage(Response);
    }
    form.resetFields();
    dispatch(GetUsersDataAction());
  };
  // Function to handle cancellation of user creation
  const HandleCancelUserCreation = () => {
    setShowCreateUser(false);
    form.resetFields();
  };

  return (
    <div className="User-Creation-Container FlexingRow">
      {/* FloatButton to trigger user creation */}
      <FloatButton
        tooltip={<div>Add New User</div>}
        icon={<UserAddOutlined className="User-Float-Icon" />}
        type="default"
        className="User-Float-Button"
        onClick={() => setShowCreateUser(true)}
      />

      {/* Modal for user creation */}
      <Modal
        open={ShowCreateUser}
        onCancel={HandleCancelUserCreation}
        footer={false}
      >
        <div className="centered-content">Create User</div>
        {/* User creation form */}
        <Form form={form} onFinish={HandleCreateUser}>
          <Form.Item
            name="First_Name"
            rules={[
              { required: true, message: " " },
              {
                pattern: /^[^\s]+(\s+[^\s]+)*$/,
                message: "First name cannot contain only spaces.",
              },
            ]}
          >
            <Input
              size="large"
              placeholder="First Name"
              prefix={<UserOutlined className="User-Creation-Icons" />}
            />
          </Form.Item>
          <Form.Item
            name="Last_Name"
            rules={[
              { required: true, message: " " },
              {
                pattern: /^[^\s]+(\s+[^\s]+)*$/,
                message: "Last name cannot contain only spaces.",
              },
            ]}
          >
            <Input
              size="large"
              placeholder="Last Name"
              prefix={<UserOutlined className="User-Creation-Icons" />}
            />
          </Form.Item>
          <Form.Item name="Email" rules={[{ required: true, message: " " }]}>
            <Input
              size="large"
              placeholder="Email"
              type="Email"
              prefix={<MailOutlined className="User-Creation-Icons" />}
            />
          </Form.Item>
          <Form.Item name="Password" rules={[{ required: true, message: " " }]}>
            <Input.Password
              size="large"
              placeholder="Password"
              prefix={<LockOutlined className="User-Creation-Icons" />}
            />
          </Form.Item>
          <Form.Item name="Role" rules={[{ required: true, message: "" }]}>
            <Select size="large" placeholder="Select Role">
              {roles.map((role) => (
                <Option key={role} value={role} label={role}>
                  {role}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <div className="centered-content">
            <Button
              style={{ backgroundColor: "#002766", color: "#fff" }}
              htmlType="submit"
            >
              Add User
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};
export default UserCreation;
